import { localeCommon } from '@lib/tools/locale/source/web/common';

import Button from '@components/web/src/atoms/Buttons/Button';
import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { Image } from '@components/web/src/foundations/Image/Image';
import { COLORS } from '@components/web/src/styles';

interface Props {
  footerLogo: string;
  handleRetailerPrivacyLink?: () => void | null;
  isPrivacyPage?: boolean;
}

export const ExternalFooter = ({ footerLogo, handleRetailerPrivacyLink, isPrivacyPage = false }: Props) => {
  const { privacyPolicyTitle } = localeCommon.commonMessages;

  return (
    <Flexbox align="center" direction="column" gap={5} justify="center" padding="30px">
      <Image alt="footerLogo" height="auto" src={footerLogo} width="166px" />
      {!isPrivacyPage && (
        <Button
          fontSize="body3"
          text={privacyPolicyTitle}
          textColor={COLORS.base.black}
          variant="link"
          onClick={handleRetailerPrivacyLink}
        />
      )}
    </Flexbox>
  );
};
